"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_router_dom_1 = require("react-router-dom");

var semantic_ui_react_1 = require("semantic-ui-react");

var data_1 = require("../data");

var StoriesPage =
/** @class */
function (_super) {
  __extends(StoriesPage, _super);

  function StoriesPage(props) {
    return _super.call(this, props) || this;
  }

  StoriesPage.prototype.render = function () {
    var _this = this;

    return React.createElement(semantic_ui_react_1.Grid, {
      centered: true,
      divided: 'vertically',
      padded: true,
      relaxed: false
    }, data_1.Stories.map(function (story, index) {
      return React.createElement(React.Fragment, {
        key: "story-" + index
      }, _this.renderSingleFeaturedStory(story));
    }));
  };

  StoriesPage.prototype.renderSingleFeaturedStory = function (story) {
    return React.createElement(semantic_ui_react_1.Grid.Row, {
      columns: 3
    }, React.createElement(semantic_ui_react_1.Grid.Column, null, React.createElement("img", {
      src: story.icon,
      style: {
        height: '90px',
        width: '90px'
      },
      alt: "story " + story.title + " icon"
    })), React.createElement(semantic_ui_react_1.Grid.Column, {
      textAlign: 'left'
    }, React.createElement(semantic_ui_react_1.Header, null, story.title), React.createElement("p", null, React.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, "Description: "), story.description), React.createElement("p", null, React.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, "Analysis authors: "), story.authors.length === 2 ? story.authors[0] + " and " + story.authors[1] : story.authors.join(', ')), React.createElement("br", null)), React.createElement(semantic_ui_react_1.Grid.Column, null, React.createElement(semantic_ui_react_1.Button, {
      basic: true
    }, React.createElement(react_router_dom_1.Link, {
      to: story.link
    }, "launch"))));
  };

  return StoriesPage;
}(React.Component);

exports.StoriesPage = StoriesPage;